import React from 'react';
import { Box, Text, HStack, Button, Link, Image } from '@chakra-ui/react';


const Api = () => {
  return (
    <Box
      w="full"
      bg='#1F1F29'
      h={['100%', '100vh']}
      alignItems="center"
      justifyContent="center"
      display="flex"
      p={['1.75rem', '2rem', '2rem', '3rem']}
    >
      <Box
        w="full"
        display="flex"
        flexDirection={['column-reverse', 'row']}
        alignItems="center"
        justifyContent="center"
        gap={6}
      >
        <Box w={['100%', '50%', '50%', '50%']}>
        <Image m="auto" w="" h="100%" src="/Rectangle.png" alt="mobile" />
        </Box>
        <Box w={['100%', '50%', '50%', '50%']} float="right" pl={['',"1.5rem"]}>
          <Text
            fontSize={['24px', '2rem', '2.5rem', '3rem']}
            lineHeight={['32px','72px']}
            color="#fff"
            mt="1rem"
            fontFamily='Duplicate Sans'
            fontWeight="500"
          >
            Build awesome <br/>
products with our API
          </Text>
          <Text
            fontSize={['.75rem', '1rem']}
            lineHeight="28px"
            mt="1rem"
            fontFamily='Work Sans'
            color="#fff"
          >
            Integrate our concise and well-documented APIs to enable you 
build the seemingly impossible.
          </Text>
          <HStack mt="1.5rem" gap={['4', '2', '2', '2']}>
          <Button
            href="#services"
            _hover={{ textDecoration: 'none' }}
            textAlign="center"
            fontSize={['.7rem', '1rem', '.7rem', '1rem']}
            color="#fff"
            bg="#246BFD"
            p=".15rem 1rem"
            fontFamily='Work Sans'
            borderRadius="16px"
            fontWeight="500"
            _active={{ color: '#000' }}
          >
            Get API&nbsp;{' '}
            <Image
              src="/hero_arrow.png"
              _hover={{ marginLeft: '.2rem' }}
              alt="socials"
              boxSize={['1rem','none']}
            />
          </Button>
            <Link
              _hover={{ textDecoration: 'none' }}
              textAlign="center"
              fontSize={['.7rem', '1rem', '.7rem', '1rem']}
              color="#fff"
              display="flex"
              fontFamily='Work Sans'
              alignItems="center"
              fontWeight="500"
              _active={{ color: '#000' }}
            >
              Read API Documentation&nbsp;{' '}
              <Image
                src="/hero_arrow.png"
                _hover={{ marginLeft: '.2rem' }}
                alt="socials"
                boxSize={['1rem','none']}
              />
            </Link>
          </HStack>
        </Box>
        
      </Box>
    </Box>
  );
};

export default Api;
